<template>
  <div class="read-more-container">
    <span :aria-label="text">{{ textToShow }}</span>
    <button v-if="textLength > maxCharacters" @click="toggleText">{{ buttonLabel }}</button>
  </div>
</template>

<script lang="ts">
import { computed, Ref, ref, toRef } from 'vue';
import truncateString from '@/utils/truncateText';
import { useI18n } from 'vue-i18n';

export default {
  name: 'ReadMoreText',
  props: {
    text: {
      default: '',
      type: String,
    },
  },
  setup(props: { text: string }): {
    maxCharacters: number;
    textToShow: Ref<string>;
    toggleText: () => void;
    buttonLabel: Ref<string>;
    textLength: Ref<number>;
  } {
    const text = toRef(props, 'text');
    const { t } = useI18n();

    const maxCharacters = 280;
    const textLength: Ref<number> = computed(() => text.value?.length ?? 0);
    const moreText = ref(textLength.value > maxCharacters);
    const toggleText = () => (moreText.value = !moreText.value);

    const textToShow: Ref<string> = computed(() =>
      moreText.value ? truncateString(text.value, maxCharacters) : text.value,
    );
    const buttonLabel: Ref<string> = computed(() => (moreText.value ? t('READ MORE') : t('READ LESS')));

    return {
      maxCharacters,
      textToShow,
      toggleText,
      buttonLabel,
      textLength,
    };
  },
};
</script>

<style lang="scss" scoped>
.read-more-container {
  > button {
    appearance: none;
    border: none;
    background: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.17px;
    color: #1b5bd8;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
